import { Pipe, PipeTransform } from "@angular/core";
import { ModuleLayout } from "../helpers/module-categories.helper";

@Pipe({
    name: 'moduleLink',
    pure: true,
    standalone: false
})

export class ModuleLinkPipe implements PipeTransform {
  transform(category: any, args?: any): any {
    let modlayout = ModuleLayout.find(m => m.category == category);
    return modlayout?.link;
  }
}
